import { Button, Flex, Popover, Portal, Text } from "@chakra-ui/react";

const SelectList = (props) => {
  if (!(props.items && props.items[0])) {
    return null;
  }
  return (
    <Popover.Body>
      <Flex overflow="hidden" direction={"column"} alignItems={"flex-start"}>
        {props.items.map((a) => (
          <Popover.Trigger
            w={"100%"}
            key={a?.key}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <Button
              onClick={(e) => {
                if (props?.onSelect) {
                  props.onSelect(a);
                }
              }}
              justifyContent={"flex-start"}
              w={"100%"}
              variant={"ghost"}
            >
              <Text my="4">{a.label}</Text>
            </Button>
          </Popover.Trigger>
        ))}
      </Flex>
    </Popover.Body>
  );
};

// const OG = (props) => {
//   <Popover.Body>
//     <Popover.Title fontWeight="medium">{props.title ?? ""}</Popover.Title>
//     <Text my="4">
//       Naruto is a Japanese manga series written and illustrated by Masashi
//       Kishimoto.
//     </Text>
//     <Input placeholder="Your fav. character" size="sm" />
//   </Popover.Body>;
// };

const PopOverComp = (props) => {
  if (props?.display === "none") {
    return null;
  }

  let Body = null;

  if (props?.Body === "selectlist") {
    Body = SelectList(props);
  } else if (props?.Body) {
    Body = props.Body;
  }

  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        {/* <Button size="sm" variant="outline">
          Click me
        </Button> */}
        {props?.TriggerComp && props.TriggerComp}
      </Popover.Trigger>
      <Portal>
        <Popover.Positioner>
          <Popover.Content width="auto">
            <Popover.Arrow />
            {Body}
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
};

export default PopOverComp;
